import _definePage_default_0 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/analytics/index.vue?definePage&vue'
import _definePage_default_3 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/colors/index.vue?definePage&vue'
import _definePage_default_4 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/customers/index.vue?definePage&vue'
import _definePage_default_5 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/forgot-password.vue?definePage&vue'
import _definePage_default_6 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/job/index.vue?definePage&vue'
import _definePage_default_7 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/job/[id].vue?definePage&vue'
import _definePage_default_8 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/jobs/index.vue?definePage&vue'
import _definePage_default_9 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/jobs/invoicing/index.vue?definePage&vue'
import _definePage_default_10 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/jobs/prepress/index.vue?definePage&vue'
import _definePage_default_11 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/jobs/production/index.vue?definePage&vue'
import _definePage_default_12 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/login.vue?definePage&vue'
import _definePage_default_13 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/logs/index.vue?definePage&vue'
import _definePage_default_14 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/not-authorized.vue?definePage&vue'
import _definePage_default_15 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/permissions/index.vue?definePage&vue'
import _definePage_default_16 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/profile/account-settings/[tab].vue?definePage&vue'
import _definePage_default_17 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/roles/index.vue?definePage&vue'
import _definePage_default_18 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/screens/index.vue?definePage&vue'
import _definePage_default_19 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/services/index.vue?definePage&vue'
import _definePage_default_20 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/statuses/index.vue?definePage&vue'
import _definePage_default_21 from '/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/translations/index.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/analytics',
    /* internal name: 'analytics' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'analytics',
        component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/analytics/index.vue'),
        /* no children */
      },
  _definePage_default_2
  )
    ],
  },
  {
    path: '/colors',
    /* internal name: 'colors' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'colors',
        component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/colors/index.vue'),
        /* no children */
      },
  _definePage_default_3
  )
    ],
  },
  {
    path: '/customers',
    /* internal name: 'customers' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'customers',
        component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/customers/index.vue'),
        /* no children */
      },
  _definePage_default_4
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/forgot-password.vue'),
    /* no children */
  },
  _definePage_default_5
  ),
  {
    path: '/job',
    /* internal name: 'job' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'job',
        component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/job/index.vue'),
        /* no children */
      },
  _definePage_default_6
  ),
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'job-id',
        component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/job/[id].vue'),
        /* no children */
      },
  _definePage_default_7
  )
    ],
  },
  {
    path: '/jobs',
    /* internal name: 'jobs' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'jobs',
        component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/jobs/index.vue'),
        /* no children */
      },
  _definePage_default_8
  ),
      {
        path: 'invoicing',
        /* internal name: 'jobs-invoicing' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'jobs-invoicing',
            component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/jobs/invoicing/index.vue'),
            /* no children */
          },
  _definePage_default_9
  )
        ],
      },
      {
        path: 'prepress',
        /* internal name: 'jobs-prepress' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'jobs-prepress',
            component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/jobs/prepress/index.vue'),
            /* no children */
          },
  _definePage_default_10
  )
        ],
      },
      {
        path: 'production',
        /* internal name: 'jobs-production' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'jobs-production',
            component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/jobs/production/index.vue'),
            /* no children */
          },
  _definePage_default_11
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/login.vue'),
    /* no children */
  },
  _definePage_default_12
  ),
  {
    path: '/logs',
    /* internal name: 'logs' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'logs',
        component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/logs/index.vue'),
        /* no children */
      },
  _definePage_default_13
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_14
  ),
  {
    path: '/permissions',
    /* internal name: 'permissions' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'permissions',
        component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/permissions/index.vue'),
        /* no children */
      },
  _definePage_default_15
  )
    ],
  },
  {
    path: '/profile',
    /* internal name: 'profile' */
    /* no component */
    children: [
      {
        path: 'account-settings',
        /* internal name: 'profile-account-settings' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':tab',
            name: 'pages-profile-account-settings-tab',
            component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/profile/account-settings/[tab].vue'),
            /* no children */
          },
  _definePage_default_16
  )
        ],
      }
    ],
  },
  {
    path: '/roles',
    /* internal name: 'roles' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'roles',
        component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/roles/index.vue'),
        /* no children */
      },
  _definePage_default_17
  )
    ],
  },
  {
    path: '/screens',
    /* internal name: 'screens' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'screens',
        component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/screens/index.vue'),
        /* no children */
      },
  _definePage_default_18
  )
    ],
  },
  {
    path: '/services',
    /* internal name: 'services' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'services',
        component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/services/index.vue'),
        /* no children */
      },
  _definePage_default_19
  )
    ],
  },
  {
    path: '/statuses',
    /* internal name: 'statuses' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'statuses',
        component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/statuses/index.vue'),
        /* no children */
      },
  _definePage_default_20
  )
    ],
  },
  {
    path: '/translations',
    /* internal name: 'translations' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'translations',
        component: () => import('/private/tmp/claude-502/-Users-dima-Documents-SynologyDrive-Polyhen--claude-worktrees-material-x-missing-previews-3777aa/5eb44447-604f-47fc-8f5f-bbeaffc9665a/scratchpad/build/resources/js/pages/translations/index.vue'),
        /* no children */
      },
  _definePage_default_21
  )
    ],
  }
]
